import {
  ConversationMessageType,
  ConversationMessage,
  Message,
} from '@marketplace-web/messaging/conversation-messaging-data'

export function isMessage(
  currentMessage: ConversationMessage,
): currentMessage is ConversationMessage & { message: Message } {
  return currentMessage.entityType === ConversationMessageType.Message
}
